class addedVaccineDosageTemplate {
  constructor(title, order) {
    this.obj = {
      groupId: "00000000-0000-0000-0000-000000000000",
      order: order,
      sectionTitle: title,
      isParent: false,
      userControls: [
        {
          userControlId: "8870e4cc-c5fe-492b-ad0b-21c9faedbf06",
          name: "Givethistoday",
          type: 5,
          label: "Give this today",
          inline: false,
          required: false,
          value: "false",
          listItems: null,
          order: 1,
          parentUserControlId: null,
          isChildControl: false,
        },
        {
          userControlId: "00000000-0000-0000-0000-000000000000",
          name: "Vaccinename",
          type: 0,
          label: "Vaccine Name",
          inline: false,
          required: false,
          value: "",
          listItems: null,
          order: 1,
          parentUserControlId: "8870e4cc-c5fe-492b-ad0b-21c9faedbf06",
          isChildControl: false,
        },
        {
          userControlId: "00000000-0000-0000-0000-000000000000",
          name: "Batchnumber",
          type: 0,
          label: "Batch Number",
          inline: true,
          required: false,
          value: "",
          listItems: null,
          order: 1,
          parentUserControlId: "8870e4cc-c5fe-492b-ad0b-21c9faedbf06",
          isChildControl: false,
        },
        {
          userControlId: "00000000-0000-0000-0000-000000000000",
          name: "Expiry",
          type: 3,
          label: "Expiry",
          inline: true,
          required: false,
          value: "",
          listItems: null,
          order: 1,
          parentUserControlId: "8870e4cc-c5fe-492b-ad0b-21c9faedbf06",
          isChildControl: false,
        },
        {
          userControlId: "00000000-0000-0000-0000-000000000000",
          name: "Site",
          type: 0,
          label: "Site",
          inline: true,
          required: false,
          value: "",
          listItems: null,
          order: 1,
          parentUserControlId: "8870e4cc-c5fe-492b-ad0b-21c9faedbf06",
          isChildControl: false,
        },
        {
          userControlId: "00000000-0000-0000-0000-000000000000",
          name: "Route",
          type: 0,
          label: "Route",
          inline: true,
          required: false,
          value: "",
          listItems: null,
          order: 1,
          parentUserControlId: "8870e4cc-c5fe-492b-ad0b-21c9faedbf06",
          isChildControl: false,
        },
        {
          userControlId: "00000000-0000-0000-0000-000000000000",
          name: "Notes",
          type: 0,
          label: "Notes",
          inline: false,
          required: false,
          value: "",
          listItems: null,
          order: 1,
          parentUserControlId: "8870e4cc-c5fe-492b-ad0b-21c9faedbf06",
          isChildControl: false,
        },
        {
          userControlId: "c690d26c-b958-4846-bdfd-2b04775b314a",
          name: "Rescheduleforanotherappointment",
          type: 5,
          label: "Reschedule for another appointment",
          inline: false,
          required: false,
          value: "false",
          listItems: null,
          order: 1,
          parentUserControlId: null,
          isChildControl: false,
        },
        {
          userControlId: "00000000-0000-0000-0000-000000000000",
          name: "Appointmanetdate",
          type: 3,
          label: "Appointment Date",
          inline: true,
          required: false,
          value: "",
          listItems: null,
          order: 1,
          parentUserControlId: "c690d26c-b958-4846-bdfd-2b04775b314a",
          isChildControl: false,
        },
      ],
      templateSectionType: 4,
      isRequired: false,
    };
  }
}

export default addedVaccineDosageTemplate;
